import { render, staticRenderFns } from "./CompactSnackbar.vue?vue&type=template&id=d4984412&scoped=true"
import script from "./CompactSnackbar.vue?vue&type=script&lang=js"
export * from "./CompactSnackbar.vue?vue&type=script&lang=js"
import style0 from "./CompactSnackbar.vue?vue&type=style&index=0&id=d4984412&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4984412",
  null
  
)

export default component.exports